import { useState } from 'react'
import { C } from '../landing.theme'
import { Ic } from '../ui/Ic'
import { Fade } from '../ui/Fade'
import { ConsultModal } from '../components/ConsultModal'

const FAQS = [
  {
    q: 'Это бесплатно?',
    a: 'Да, полностью и без каких-либо условий. Конфигуратор, подбор оборудования, расчёт стоимости и выгрузка PDF-спецификации - всё это бесплатно. Никаких скрытых платежей и звонков «для получения цены» - всё прозрачно сразу на экране.',
  },
  {
    q: 'Вы строите бассейны?',
    a: 'Нет, строительством мы не занимаемся. Наша специализация - подбор и поставка профессионального оборудования для бассейнов, саун и хаммамов. Монтаж выполняет ваш подрядчик, а мы при необходимости дадим технические рекомендации и схемы подключения - чтобы всё работало правильно с первого раза.',
  },
  {
    q: 'Насколько точен расчёт?',
    a: 'Подбор оборудования выполняется автоматически по инженерным формулам - система сама рассчитывает мощность насоса, объём фильтра, производительность теплообменника и другие параметры под ваш бассейн. Цены в расчёте актуальные, но небольшое расхождение в пределах 5–10% возможно из-за колебаний курса на момент фактической закупки. Финальная стоимость фиксируется в договоре после консультации с менеджером.',
  },
  {
    q: 'Какие бренды есть?',
    a: 'Работаем с проверенными производителями из Европы и Азии: Pahlen, Emaux, Landy, Aqua-Viva, Elbe, Reviglass, Glong, Max Dapra, HX, Altoglass, CGT и другими. Под любой бюджет подберём оптимальное сочетание надёжности и цены - не переплачивая за бренд там, где это не нужно.',
  },
  {
    q: 'Что входит в PDF-спецификацию?',
    a: 'Полный перечень оборудования с артикулами, техническими характеристиками и ценами на момент расчёта. Цены в документе актуальные, но могут незначительно отличаться от финальных из-за курса валют - итоговая стоимость уточняется у менеджера. Документ удобно передать подрядчику, использовать для сравнения предложений или сразу прислать нам для выставления счёта.',
  },
  {
    q: 'Как получить консультацию?',
    a: 'Настройте параметры вашего объекта в конфигураторе и нажмите «Получить консультацию» - менеджер свяжется в течение часа. Можно также написать напрямую в WhatsApp или позвонить. Уточним детали, при необходимости скорректируем подбор и ответим на все технические вопросы.',
  },
]

function PlusIcon({ open }) {
  return (
    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" style={{ display:'block', transition:'transform .28s ease', transform: open ? 'rotate(45deg)' : 'none' }}>
      <line x1="5" y1="0.5" x2="5" y2="9.5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"/>
      <line x1="0.5" y1="5" x2="9.5" y2="5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"/>
    </svg>
  )
}

export default function Faq() {
  const [open, setOpen] = useState(0)
  const [consult, setConsult] = useState(false)
  return (
    <section className="sec" id="faq" style={{ background:C.paper }}>
      <div className="wrap">
        <div className="g-faq" style={{ display:'grid', gridTemplateColumns:'.75fr 1.25fr', gap:52, alignItems:'start' }}>

          {/* Левая колонка: заголовок */}
          <Fade style={{ paddingTop:40, textAlign:'center' }}>
            <span className="eb light">ВОПРОСЫ</span>
            <h2 className="chrome-ink" style={{ fontSize:'clamp(24px,3.2vw,38px)', marginTop:16 }}>Частые вопросы</h2>
            <p style={{ color:C.ink2, fontSize:15.5, lineHeight:1.68, marginTop:14 }}>Не нашли ответ? Напишите -<br/>отвечаем быстро.</p>
            <div style={{ marginTop:24 }}>
              <button className="btn btn-ol" onClick={() => setConsult(true)}><Ic n="phone" s={15}/>Задать вопрос</button>
            </div>
          </Fade>

          {/* Правая колонка: аккордеон */}
          <Fade delay={90}>
            {FAQS.map((f, i) => (
              <div
                key={i}
                onClick={() => setOpen(open === i ? -1 : i)}
                style={{
                  background:'#fff',
                  border:`1px solid ${open === i ? C.teal : 'rgba(10,32,40,.08)'}`,
                  borderRadius:14,
                  padding:'0 20px',
                  cursor:'pointer',
                  marginBottom:8,
                  transition:'border-color .22s,box-shadow .22s',
                  boxShadow: open === i ? '0 4px 20px rgba(6,32,46,.09)' : 'none',
                }}
              >
                <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', gap:14, padding:'17px 0' }}>
                  <span style={{ fontWeight:700, fontSize:15, color:C.ink, lineHeight:1.4 }}>{f.q}</span>
                  <span style={{
                    width:28, height:28, borderRadius:'50%', flexShrink:0,
                    background: open === i ? 'rgba(10,123,134,.1)' : 'rgba(10,32,40,.05)',
                    border:`1.5px solid ${open === i ? C.teal : 'rgba(10,32,40,.14)'}`,
                    display:'flex', alignItems:'center', justifyContent:'center',
                    color: open === i ? '#0A7B86' : '#4A6070',
                    transition:'background .22s,border-color .22s,color .22s',
                  }}>
                    <PlusIcon open={open === i}/>
                  </span>
                </div>
                <div style={{ display:'grid', gridTemplateRows: open === i ? '1fr' : '0fr', transition:'grid-template-rows .3s ease' }}>
                  <p style={{ overflow:'hidden', fontSize:14.5, lineHeight:1.68, color:C.ink2, margin:0, paddingBottom: open === i ? 16 : 0 }}>{f.a}</p>
                </div>
              </div>
            ))}
          </Fade>

        </div>
      </div>
      <ConsultModal open={consult} onClose={() => setConsult(false)} />
    </section>
  )
}
